"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipResponseValidator = void 0;
var PipResponseValidator = /** @class */ (function () {
    function PipResponseValidator(tokenValidator) {
        this.tokenValidator = tokenValidator;
    }
    PipResponseValidator.prototype.validate = function (response) {
        if (response.length <= 0) {
            return {
                isValid: false,
                reason: "PIP_RESPONSE_EMPTY",
            };
        }
        var parseResult = parseJson(response);
        if (parseResult === null) {
            return {
                isValid: false,
                reason: "PIP_RESPONSE_INVALID_JSON",
            };
        }
        if (typeof parseResult.isVtmGoPlus !== "boolean") {
            return {
                isValid: false,
                reason: "PIP_RESPONSE_INVALID_STRUCTURE",
            };
        }
        if (typeof parseResult.access_token !== "string" ||
            typeof parseResult.id_token !== "string" ||
            typeof parseResult.userinfo_token !== "string") {
            return {
                isValid: false,
                reason: "PIP_RESPONSE_INVALID_STRUCTURE",
            };
        }
        var idTokenValidation = this.tokenValidator.validate(parseResult.id_token);
        if (!idTokenValidation.isValid) {
            return idTokenValidation;
        }
        return {
            isValid: true,
            payload: {
                data: idTokenValidation.payload.data,
                accessToken: parseResult.access_token,
                uitToken: parseResult.userinfo_token,
                isVtmGoPlus: parseResult.isVtmGoPlus,
            },
        };
    };
    return PipResponseValidator;
}());
exports.PipResponseValidator = PipResponseValidator;
var parseJson = function (response) {
    try {
        return JSON.parse(response);
    }
    catch (error) {
        return null;
    }
};
